import React from 'react';
import { EnvelopeIcon, PhoneIcon, MapPinIcon } from '@heroicons/react/24/outline';

export default function Contact() {
  return (
    <div className="min-h-screen">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">

        {/* Contenu */}
        <div className="text-center">
          <h1 className="text-4xl font-bold text-slate-900 mb-6">
            Nous contacter
          </h1>
          
          <div className="space-y-6">
            <p className="text-lg text-slate-600">
              Vous avez une question ? N'hésitez pas à nous contacter.
            </p>

            <div className="bg-white rounded-xl p-8 grid gap-36 md:grid-cols-3 mt-8 text-left">
              {/* Email */}
              <div className="flex items-start">
                <div className="flex-shrink-0">
                  <div className="flex items-center justify-center h-12 w-12 rounded-lg bg-honey-100">
                    <EnvelopeIcon className="h-6 w-6 text-honey-600" />
                  </div>
                </div>
                <div className="ml-4">
                  <h3 className="text-lg font-medium text-slate-900">Email</h3>
                  <p className="mt-1 text-slate-600">
                    <a href="mailto:abeillereunion@gmail.com" className="text-honey-600 hover:text-honey-700">
                      abeillereunion@gmail.com
                    </a>
                  </p>
                </div>
              </div>

              {/* Téléphone */}
              <div className="flex items-start">
                <div className="flex-shrink-0">
                  <div className="flex items-center justify-center h-12 w-12 rounded-lg bg-honey-100">
                    <PhoneIcon className="h-6 w-6 text-honey-600" />
                  </div>
                </div>
                <div className="ml-4">
                  <h3 className="text-lg font-medium text-slate-900">Téléphone</h3>
                  <p className="mt-1 text-slate-600">
                    À venir
                  </p>
                </div>
              </div>

              {/* Adresse */}
              <div className="flex items-start">
                <div className="flex-shrink-0">
                  <div className="flex items-center justify-center h-12 w-12 rounded-lg bg-honey-100">
                    <MapPinIcon className="h-6 w-6 text-honey-600" />
                  </div>
                </div>
                <div className="ml-4">
                  <h3 className="text-lg font-medium text-slate-900">Adresse</h3>
                  <p className="mt-1 text-slate-600">
                    À venir
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
